<template>
  <div class="tw-text-center timeline-action-btn-wrap">
    <div class="tw-flex tw-justify-center">
      <div class="tw-shadow-lg tw-rounded-full tw-border-2 tw-border-black">
        <button
          :class="{
            'tw-bg-yellow-250': currentView === 'resourceTimelineWeek',
          }"
          class="btn-cal-switch btn md:tw-px-6 sm:tw-px-3 tw-text-gray-800 tw-rounded-full tw-rounded-r-none tw-border-r-2 tw-border-black focus:tw-border-black"
          type="button"
          data-cy="btn-week-view"
          @click="setCurrentView('resourceTimelineWeek')"
        >
          Week
        </button>
        <button
          :class="{
            'tw-bg-yellow-250': currentView === 'resourceTimelineMonth',
          }"
          class="btn-cal-switch btn md:tw-px-6 sm:tw-px-3 tw-text-gray-800 tw-rounded-none btn-month-view tw-border-r-2 tw-border-black focus:tw-border-black"
          type="button"
          data-cy="btn-month-view"
          @click="setCurrentView('resourceTimelineMonth')"
        >
          Month
        </button>
        <button
          :class="{
            'tw-bg-yellow-250': currentView === 'resourceTimeline30Days',
          }"
          class="btn-cal-switch btn md:tw-px-6 sm:tw-px-3 tw-text-gray-800 tw-rounded-full tw-rounded-l-none focus:tw-border-black"
          type="button"
          data-cy="btn-30days-view"
          @click="setCurrentView('resourceTimeline30Days')"
        >
          30 Days
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Mousetrap from 'mousetrap'

export default {
  name: 'TimelineViewSwitcher',

  props: {
    currentView: {
      type: String,
      required: true,
    },
  },

  mounted() {
    Mousetrap.bind('w', e => {
      e.preventDefault()
      this.$emit('change', 'resourceTimelineWeek')
    })

    Mousetrap.bind('m', e => {
      e.preventDefault()
      this.$emit('change', 'resourceTimelineMonth')
    })

    this.$once('hook:beforeDestroy', () => {
      Mousetrap.unbind('w')
      Mousetrap.unbind('m')
    })
  },

  methods: {
    setCurrentView(view) {
      if (view != 'resourceTimelineDay') {
        this.inActiveEmploymentTimezone = false
      }
      this.$emit('change', view)
    },
  },
}
</script>
